import styled from 'styled-components';
import tinycolor from 'tinycolor2';
import { Color } from '../../common/base';
import getReadibilityColor from '../../common/utils/styles/utils/readibility';

const ReportsWrapper = styled.div`
  background-image: ${({ theme: { colors } }) =>
    `linear-gradient(180deg, ${colors.gray.light}, ${colors.gray.light})`};
  color: ${({ theme }) => getReadibilityColor(theme.colors.gray.light, theme)};
  padding-bottom: 100px;
`;

const ReportsTitle = styled.div`
  padding-top: 100px;
  border-top: 1px solid ${Color.greyDark};
  margin-bottom: 60px;
`;

export { ReportsWrapper, ReportsTitle };
